// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const putDeactivateUser = async (namespace: string, userId: string) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.put(
      `${url}/api/v1/ns/${namespace}/users/${userId}/deactivate`,
      {},
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      throw err;
    } else {
      throw new Error("An unexpected error occurred while deactivating user.");
    }
  }
};
